import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Slider from "nx-components/Slider";
import prefixStyles from "nx-components/utils/prefixStyles";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";

const sliderStyle = prefixStyles({ flex: "1 0 auto", margin: "1em 0.5em" });

export default class Fan extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isDetailed: PropTypes.bool.isRequired,
    showSpinner: PropTypes.func.isRequired, // (?string) => void
    hideSpinner: PropTypes.func.isRequired, // () => void
  };

  state = {
    pendingValue: null,
  };

  _isEditing = false;

  shouldComponentUpdate() {
    // If the user is editing the fan value, stay out of
    // their way. We'll miss an update, but that's okay,
    // because they're about to set a new value.
    return !this._isEditing;
  }

  _handleDragStart = () => {
    this._isEditing = true;
    Dispatch("DISABLE_LOCATION_POLLING");
  };

  _handleDragEnd = (value) => {
    this._isEditing = false;
    Dispatch("ENABLE_LOCATION_POLLING");
    const { model, showSpinner, hideSpinner } = this.props;

    if (value === model.get("fan_speed")) {
      return; // don't set fan speed if it hasn't changed
    }

    this.setState({ pendingValue: value });
    showSpinner(`Setting speed for '${model.get("name")}'`);
    const onDone = () => {
      hideSpinner();
      this.setState({ pendingValue: null });
    };
    model.setFanSpeed(value).then(() => {
      model.fetch().then(onDone, onDone);
    }, onDone);
  };

  _formatValue = (value) => {
    return this.props.model.getFanSpeedLabel(value);
  };

  render() {
    const { model, isDetailed } = this.props;
    const { pendingValue } = this.state;

    let displayValue = model.get("fan_speed");
    if (pendingValue != null) {
      displayValue = pendingValue;
    }

    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <Slider
          min={0}
          max={99}
          step={model.get("fan_speed_increment")}
          value={displayValue}
          formatValue={this._formatValue}
          onDragStart={this._handleDragStart}
          onDragEnd={this._handleDragEnd}
          style={sliderStyle}
        />
      </CommonControlWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Fan.jsx